import Styles from './EmptyState.module.scss'
import { ReactComponent as CheckIcon } from 'assets/icons/checkmark16.svg'

export const EmptyState = () => {
  return (
    <div className={Styles.container}>
      <div className={Styles.icon}>
        <CheckIcon />
      </div>
      <span className={Styles.label}>You're all caught up!</span>
      <div className={Styles.text}>File access requests, tasks & comment mentions will show up here.</div>
    </div>
  )
}
